import React from 'react';

class NotificationErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Actualiza el estado para mostrar la UI de error
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log del error para debugging
    console.error('[NotificationErrorBoundary] Error capturado:', error);
    console.error('[NotificationErrorBoundary] Error info:', errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // UI de fallback cuando hay error - invisible para el usuario
      console.warn('[NotificationErrorBoundary] Componente de notificaciones falló, continuando sin notificaciones visuales');
      return null;
    }

    return this.props.children;
  }
}

export default NotificationErrorBoundary;